import $ from "jquery";
import objectFitImages from "object-fit-images";
import svg4everybody from "svg4everybody";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "lazysizes";
import "picturefill";
import "responsive-bp";
import "@fancyapps/fancybox";
import "slick-carousel";

import filter from "./filter";
import uiHelpers from "./ui-helpers";

svg4everybody();
uiHelpers.init();
objectFitImages();

// include any plugin initialisation here
// any custom JS that needs to be written should be modular (and in a separate file), possibly done as a jQuery plugin or some other modular form, and initialised here like the other plugins
$(".no-js").removeClass("no-js");

// Send scrolling events to Google Analytics http://scrolldepth.parsnip.io/
if (typeof $.scrollDepth === "function") {
  $.scrollDepth();
}

$.fn.isInViewport = function() {
  const elementTop = $(this).offset().top;
  const elementBottom = elementTop + $(this).outerHeight();

  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return elementBottom < viewportBottom;

  // return elementBottom > viewportTop && elementTop < viewportBottom;
};

if ($(".grid__link").length > 0) {
  $(window).on("resize scroll", function() {
    $(".grid__link").each(function() {
      if ($(this).isInViewport()) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });
  });
}

// Navigation
function addListenersToNav() {
  if ($(window).width() <= 1280) {
    // Unbind
    $(".js-menu-toggle").unbind("click");

    // Rebind
    $(".js-menu-toggle").on("click", function(e) {
      $(this).toggleClass("active");
      $(".js-menu").toggleClass("active");
      $("html, body").toggleClass("no-scroll");
      e.preventDefault();
    });
  }
}

addListenersToNav();

// Image caption height calculation
function captionSizes() {
  if ($(window).width() >= 720) {
    let maxHeight = 0;

    $(".js-caption").each(function() {
      const height = $(this).outerHeight();

      if (height > maxHeight) {
        maxHeight = height;

        $(this)
          .parents(".content-panel__row")
          .css("padding-bottom", maxHeight);
      }
    });
  }
}

captionSizes();

$(window).resize(() => {
  addListenersToNav();
  captionSizes();
});

// Sticky header
let stickyPoint = 80;

if ($(window).width() <= 1280) {
  stickyPoint = 20;
}

function headerScrolled() {
  const scrollPos = $(document).scrollTop();
  if (scrollPos > stickyPoint) {
    $(".primary-header, .alert-bar").addClass("scrolled");
  } else {
    $(".primary-header, .alert-bar").removeClass("scrolled");
  }
}

headerScrolled();

$(window).scroll(() => {
  headerScrolled();
});

// Slick - Slider
$(".js-slider").each(function() {
  let slideCount = $(this).data("slides");

  if (!slideCount) {
    slideCount = 3;
  }

  let arrows = false;
  if ($(this).hasClass("hero__slides")) {
    arrows = true;
  }

  $(this).slick({
    arrows,
    centerMode: true,
    centerPadding: "80px",
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 720,
        settings: {
          centerPadding: "40px",
          slidesToShow: 1
        }
      },
      {
        breakpoint: 420,
        settings: {
          centerPadding: "20px",
          slidesToShow: 1
        }
      }
    ],
    slidesToShow: slideCount
  });
});

// Slick - Gallery
$(".js-gallery-carousel").each(function() {
  const slideCount = $(this).data("slides");

  if (slideCount === 1 && $(window).width() >= 720) {
    $(this).slick({
      arrows: true,
      slidesToShow: 1
    });
  } else {
    $(this).slick({
      arrows: false,
      centerMode: true,
      centerPadding: "120px",
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            centerPadding: "80px"
          }
        },
        {
          breakpoint: 720,
          settings: {
            centerPadding: "40px"
          }
        },
        {
          breakpoint: 420,
          settings: {
            centerPadding: "20px"
          }
        }
      ],
      slidesToShow: 1
    });
  }
});

// Slick - Carousel
$(".js-carousel").each(function() {
  $(this).slick({
    arrows: true,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    adaptiveHeight: true
  });
});

$(".primary-navigation__list-item--has-subnav > a").on("click touch", function(
  e
) {
  if ($(window).width() <= 1280) {
    e.preventDefault();
    $(this)
      .parents(".primary-navigation__list-item--has-subnav")
      .find(".primary-navigation__sublist")
      .slideToggle(500);
  }
});

// Slick - Fader
$(".js-fader").each(function() {
  let arrows = false;
  if ($(this).hasClass("hero__slides")) {
    arrows = true;
  }
  console.log(arrows);
  $(this).slick({
    arrows,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 1,
    speed: 1000
  });
});

// Accordions
const acc = document.getElementsByClassName("js-accordion");
let i: number;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    const panel = this.nextElementSibling;

    this.parentNode.classList.toggle("active");

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Tabbed content
$(".js-tab").on("click", function() {
  const index = $(this).index() + 1;
  const tabList = $(this).parent();
  const tabs = tabList.parent().next();

  $(this)
    .addClass("active")
    .siblings()
    .removeClass("active");
  tabs.find("> div").removeClass("active");
  tabs.find("> div:nth-child(" + index + ")").addClass("active");
  tabList.removeClass("open");
});

$(".js-mobile-tab").on("click", function(e) {
  const tabList = $(this).next();
  tabList.toggleClass("open");
  e.preventDefault();
});

// Filtering
if ($(".js-filter").length) {
  filter.init();
}

// Expanding Careeers
$(".js-careers-vacancy").each(function() {
  const h = $(this).height();
  $(this)
    .attr("style", "--vacancy-height: " + h + "px;")
    .addClass("ready");
});

$(".js-careers-expand").on("click", function() {
  if (
    $(this)
      .prev()
      .hasClass("active")
  ) {
    $(this)
      .prev()
      .removeClass("active");
    $(this)
      .find("span")
      .text("Learn more +");
  } else {
    $(this)
      .prev()
      .addClass("active");
    $(this)
      .find("span")
      .text("Learn less -");
  }
});

// Shopify button overrides
$(document).ready(() => {
  $(".js-shopify-buy").on("click", function() {
    $(this).addClass("active");
    $(".js-shopify-product .shopify-buy__btn").trigger("click");
  });
});

// Move Shopify image to alternative location
const observer = new MutationObserver(() => {
  $(".js-shopify-image").empty();
  $(".shopify-buy__product-img-wrapper")
    .clone()
    .appendTo(".js-shopify-image");
});

observer.observe(document, {
  attributes: true,
  subtree: true
});

// Close/auto hide hero content
if ($(".js-hero-content").length) {
  const heroContent = $(".js-hero-content");
  const heroId = heroContent.data("content-id");

  if (localStorage.getItem("hero-viewed-" + heroId) !== heroId) {
    localStorage.setItem("hero-viewed-" + heroId, heroId);
    $(".js-hero-content").removeClass("hidden");
  }

  $(".js-hero-close").on("click", () => {
    localStorage.setItem("hero-viewed-" + heroId, heroId);
    $(".js-hero-content").fadeOut(300, function() {
      $(this).addClass("hidden");
    });
  });
}
